import { Controller } from 'stimulus';
import { send, INTERACTION_TYPES } from '../javascripts/apopheniaLogger';
import '../../packs/textarea';

class InlineInterviewController extends Controller {
  static targets = [
    'error',
    'formContainer',
    'invalid',
    'lottiePlayer',
    'submit',
    'success',
    'textarea'
  ];
  referralKey = window.location.pathname.split('/').pop();
  questionValue = '';
  accountKeys = [];

  handleSubmit(e) {
    this.initSubmission();

    const { providerAccountKeys } = e.target.dataset;
    this.accountKeys = providerAccountKeys.split(',');

    Promise.all(this.accountKeys.map(this.postQuestion))
      .then(this.handleSuccess)
      .catch(this.handleError);
  }

  handleSuccess = () => {
    this.clearError();
    this.formContainerTarget.classList.add('u-displayNone');
    this.successTarget.classList.remove('u-displayNone');
    this.lottiePlayerTarget.load(
      'https://assets3.lottiefiles.com/packages/lf20_IdS6YsKCG9.json'
    );
    this.lottiePlayerTarget.togglePlay();
    this.sendApopheniaLog({
      account_key: this.accountKeys,
      element_id: 'submit-custom-question',
      custom_question: this.questionValue
    });
  };

  handleError = () => {
    this.submitTarget.disabled = false;
    this.submitTarget.textContent = 'Try Again';

    this.invalidTargets.forEach((target) => {
      target.classList.add('is-invalid');
    });
    this.errorTarget.classList.remove('u-displayNone');
  };

  clearError = () => {
    this.invalidTargets.forEach((target) => {
      target.classList.remove('is-invalid');
    });
    this.errorTarget.classList.add('u-displayNone');
  };

  initSubmission = () => {
    // capture question value before submission
    this.questionValue = this.textareaTarget.value;
    this.clearError();
    this.submitTarget.disabled = true;
    this.submitTarget.textContent = 'Sending...';
  };

  postQuestion = (providerAccountKey) => {
    const url =
      '/trusted/experience/residential-real-estate/send-interview-questions';
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        account_key: providerAccountKey,
        referral_key: this.referralKey,
        questions: [this.questionValue]
      })
    };

    return fetch(url, options);
  };

  validateForm = () => {
    const { value } = this.textareaTarget;

    if (value) {
      this.submitTarget.disabled = false;
    } else {
      this.submitTarget.disabled = true;
    }
  };

  sendApopheniaLog(data) {
    const logData = {
      screen_id: window.location.href,
      section_id: 'q-and-a',
      interaction_type: INTERACTION_TYPES.CLICKED
    };
    try {
      send({
        ...logData,
        ...data
      });
    } catch (err) {
      return;
    }
  }
}

export default InlineInterviewController;
